import { z } from 'zod'

import { AD_REFRESH_MAX_INTERVAL_MS, AD_REFRESH_MIN_INTERVAL_MS } from '@/constants/ad'

export const AdRefreshConfigSchema = z.object({
  refresh_interval_ms: z.number(),
})

export const parseAdRefreshIntervalMs = (payload: unknown): number | undefined => {
  const result = AdRefreshConfigSchema.safeParse(payload)

  if (!result.success || result.data.refresh_interval_ms === 0) return undefined

  return Math.min(
    Math.max(result.data.refresh_interval_ms, AD_REFRESH_MIN_INTERVAL_MS),
    AD_REFRESH_MAX_INTERVAL_MS,
  )
}
